import React from 'react';
import { Link } from 'react-router-dom';
import { Briefcase, Facebook, Twitter, Linkedin, Instagram, Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-900 text-white pt-16 pb-8" data-id="element-21" data-mp="alnovmv157xk">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22" data-mp="ao9v9j66phe7">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12" data-id="element-23" data-mp="5masaaecwmhs">
          {/* Brand */}
          <div data-id="element-24" data-mp="pkclo6grsww">
            <div className="flex items-center space-x-2 mb-6" data-id="element-25" data-mp="q2ilcixhli0">
              <div className="p-2 rounded-lg bg-white text-navy-900" data-id="element-26" data-mp="3s1m13el6ztcy">
                <Briefcase className="h-6 w-6" data-id="element-27" data-mp="3n32gpim8ypmp" />
              </div>
              <span className="text-xl font-serif font-bold text-white" data-id="element-28" data-mp="3n1hi9hwtamjk">
                Continuum Talent Solutions
              </span>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed" data-id="element-29" data-mp="3e1ukd63ajyv9">
              Connecting exceptional talent with world-class opportunities. We
              specialize in strategic placement and career development for
              professionals worldwide.
            </p>
            <div className="flex space-x-4" data-id="element-30" data-mp="2p3l34m17ni2d">
              <a href="#" className="text-gray-400 hover:text-gold-500 transition-colors" data-id="element-31" data-mp="2p5e7fuocpq77">
                <Linkedin className="h-5 w-5" data-id="element-32" data-mp="2gbj48s6si9u7" />
              </a>
              <a href="#" className="text-gray-400 hover:text-gold-500 transition-colors" data-id="element-33" data-mp="2gbrgchv39b4c">
                <Twitter className="h-5 w-5" data-id="element-34" data-mp="382ffxph468fw" />
              </a>
              <a href="#" className="text-gray-400 hover:text-gold-500 transition-colors" data-id="element-35" data-mp="381w851l6h0fl">
                <Facebook className="h-5 w-5" data-id="element-36" data-mp="2z1r32y3gie4l" />
              </a>
              <a href="#" className="text-gray-400 hover:text-gold-500 transition-colors" data-id="element-37" data-mp="2z43sfwbjnqro">
                <Instagram className="h-5 w-5" data-id="element-38" data-mp="1nndgrxocq6qo" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-39" data-mp="13jfyqwutwtvn">
            <h3 className="text-lg font-serif font-semibold mb-6 text-gold-500" data-id="element-40" data-mp="13k7rlzx1kdi8">
              Quick Links
            </h3>
            <ul className="space-y-4" data-id="element-41" data-mp="zliabw8vubtb">
              <li data-id="element-42" data-mp="urmd4w0g0sz7">
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors" data-id="element-43" data-mp="ur4j86196qug">
                  About Us
                </Link>
              </li>
              <li data-id="element-44" data-mp="kvjfa2cmjgi2">
                <Link to="/how-it-works" className="text-gray-300 hover:text-white transition-colors" data-id="element-45" data-mp="krvkkzvg0o1r">
                  How It Works
                </Link>
              </li>
              <li data-id="element-46" data-mp="6v06gt0c46eu">
                <Link to="/testimonials" className="text-gray-300 hover:text-white transition-colors" data-id="element-47" data-mp="6vic2g8vzwzf">
                  Success Stories
                </Link>
              </li>
              <li data-id="element-48" data-mp="2199gn1cczqo0">
                <Link to="/blog" className="text-gray-300 hover:text-white transition-colors" data-id="element-49" data-mp="216n9h2tdrd6b">
                  Career Resources
                </Link>
              </li>
            </ul>
          </div>


          {/* Contact */}
          <div data-id="element-50" data-mp="2ijwyhrusnzic">
            <h3 className="text-lg font-serif font-semibold mb-6 text-gold-500" data-id="element-51" data-mp="2ngx5q63dr8b1">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-52" data-mp="1ptoc1nt86sxy">
              <li className="flex items-start space-x-3" data-id="element-53" data-mp="1pupre4h9y1lh">
                <MapPin className="h-5 w-5 text-gold-500 mt-0.5" data-id="element-54" data-mp="1urpx2ea7p2c2" />
                <span className="text-gray-300" data-id="element-55" data-mp="1uu2n7eq4ij07">
                  357 7th Ave, 2nd Floor
                  <br data-id="element-56" data-mp="1ztfb82sqdw4d" />
                  New York, NY 10001, United States
                </span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-57" data-mp="3b6hqmuj3gfmy">
                <Phone className="h-5 w-5 text-gold-500" data-id="element-58" data-mp="3b5y6d75z1f5r" />
                <span className="text-gray-300" data-id="element-59" data-mp="3f7jq9cgxatpg">+1 (678) 807-3391</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-60" data-mp="3dqnrgtcevpza">
                <Mail className="h-5 w-5 text-gold-500" data-id="element-61" data-mp="3dr5x2gkyrgjv" />
                <span className="text-gray-300" data-id="element-62" data-mp="38smcaji3wat3">
                  michaeljohnson@continuumtalentsolution.com
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-navy-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400" data-id="element-63" data-mp="3ipqz8ljs0aay">
          <p data-id="element-64" data-mp="it4xabi9k0n">
            &copy; {new Date().getFullYear()} Continuum Talent Solutions. All
            rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-65" data-mp="aa79hwibda0n">
            <a href="#" className="hover:text-white" data-id="element-66" data-mp="a9nr6eor4jm3">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white" data-id="element-67" data-mp="5bm8vvz5gobo">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}